// extracted by mini-css-extract-plugin
module.exports = {"chatbot-container":"SalesforceMessaging_chatbot-container__BRo7L","chatbotContainer":"SalesforceMessaging_chatbot-container__BRo7L"};